import { render, staticRenderFns } from "./UpdatedInformations.vue?vue&type=template&id=242d7362"
import script from "./UpdatedInformations.vue?vue&type=script&lang=js"
export * from "./UpdatedInformations.vue?vue&type=script&lang=js"
import style0 from "./UpdatedInformations.vue?vue&type=style&index=0&id=242d7362&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports